// extracted by mini-css-extract-plugin
export default {"root":"_36Jtc","variant-subscriptions":"_1OvJC","variantSubscriptions":"_1OvJC","variant-adoptables":"_28G7q","variantAdoptables":"_28G7q"};